<template>

    <div class="px-6 py-4 bg-minplan-beige -mb-4">
        <page-title :title="$t('options.newSet')"></page-title>
    </div>

    <jet-form-section @submitted="createSet()">

        <template #form>

            <form-card :title="$t('options.set')" :description="$t('options.setDescription')">

                <div class="col-span-6">
                    <label for="name" class="block text-sm font-medium text-gray-700">{{ $t("options.name") }} <RequiredMark /></label>
                    <input type="text" name="name" id="name" v-model="form.name"
                           class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300"
                           autofocus />
                    <jet-input-error :message="form.errors.name" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label for="title" class="block text-sm font-medium text-gray-700">{{ $t("options.title") }} <RequiredMark /></label>
                    <input type="text" name="title" id="title" v-model="form.title"
                           class="mt-1 focus:ring-minplan-blue focus:border-minplan-blue block w-full shadow-sm sm:text-sm border-gray-300" />
                    <jet-input-error :message="form.errors.title" class="mt-2" />
                </div>

                <div class="col-span-6">
                    <label for="description"
                           class="block text-sm font-medium text-gray-700">{{ $t("options.description") }}</label>

                    <textarea type="text" name="reason" id="description"
                              v-model="form.description"
                              class="focus:ring-minplan-blue focus:border-minplan-blue w-full mt-3"
                              autofocus></textarea>
                    <jet-input-error :message="form.errors.description" class="mt-2" />
                </div>

            </form-card>

        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">

                <button @click="cancel" type="button"
                        class="inline-block uppercase font-semibold text-xs tracking-widest">
                    {{ $t("actions.cancel") }}
                </button>

                <primary-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="ml-3 ">
                    {{ $t("actions.save") }}
                </primary-button>

            </div>
        </template>

    </jet-form-section>

</template>


<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm } from "@inertiajs/inertia-vue3";
import FormCard from "@/Shared/Components/FormCard";
import RequiredMark from "@/Shared/Components/RequiredMark";

export default defineComponent({
    props: [],
    inheritAttrs: false,
    layout: MainLayout,
    emits: ["closeModal"],
    components: {
        PageTitle,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        FormCard,
        RequiredMark
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        createSet() {
            this.form.post(this.route("advisors.option-sets.store"), {
                preserveScroll: true,
                onSuccess: () => this.$notify({
                    group: "success",
                    title: "actions.success",
                    text: "options.created"
                })
            });
        }
    },
    setup() {

        const form = useForm({
            name: null,
            title: null,
            description: null
        });

        return { form };
    }
});
</script>

<style scoped></style>
